import { createBrowserClient } from '@supabase/ssr'

export const createClient = () => {
  // Hardened env check

  const url = process.env.NEXT_PUBLIC_SUPABASE_URL || (typeof window !== 'undefined' ? (window as any).NEXT_PUBLIC_SUPABASE_URL : '')
  const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || (typeof window !== 'undefined' ? (window as any).NEXT_PUBLIC_SUPABASE_ANON_KEY : '')

  
  // Prerender safety: if env vars are missing (standard during build), 
  // we return a mock object that doesn't crash on createBrowserClient.
  if (!url || !key) {
    return {
      auth: {
        getUser: async () => ({ data: { user: null }, error: null }),
        getSession: async () => ({ data: { session: null }, error: null }),
        onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
        signInWithOtp: async () => ({ data: {}, error: null }),
        exchangeCodeForSession: async () => ({ data: {}, error: null }),
      },
      from: () => ({
        select: () => ({
          eq: () => ({
            single: async () => ({ data: null, error: null }),
            order: async () => ({ data: [], error: null }),
          }),
          order: async () => ({ data: [], error: null }),
        }),
      }),
    } as any
  }

  return createBrowserClient(url, key)
}

// Singleton for client-side use
export const supabase = createClient()
